import {API_ROOT_URL} from 'envs/_current/config'
import {baseFieldTypes} from './base/baseFieldTypes'
import {codiDocumentSchema, documentSchema} from './schema'
import {createListTransform} from './utils/createListTransform'
import {createTransform} from './utils/createTransform'

const transform = createTransform(documentSchema, 'data')
transform.toString = () => 'document_transform'
const transformArray = createListTransform(documentSchema)
transformArray.toString = () => 'document_transformArray'

const fields = [
    'description',
    'embed_data',
    'privacy',
    'user_id',
    'action',
    'content',
    'photos',
    'container_type',
    'container_id',
    'owner_type',
    'owner_id',
]

const fieldTypes = {
    photos: baseFieldTypes.image,
    description: '',
    embed_data: baseFieldTypes.object,
    privacy: '',
    content: baseFieldTypes.string,
    user_id: baseFieldTypes.auto,
    action: baseFieldTypes.auto,
    pinned: [0, 1],
    container_type: '',
    container_id: '',
    owner_type: '',
    owner_id: '',
}
// Route::get('docs/doc/{id}', 'FeedController@showPostById');
export const doc_getDocumentById_Api = {
    backend: `Route::get('docs/doc/{id}', 'FeedController@showPostById');`,
    root: API_ROOT_URL,
    path: '/docs/doc/:id',
    method: 'GET',
    schema: documentSchema,
    fields,
    fieldTypes,
    transform: createTransform(documentSchema, 'data'),
}
export const doc_updateInfo_Api = {
    backend: `Route::post('docs/doc/{id}/update-info', 'DocController@updateDocumentInfo');`,
    root: API_ROOT_URL,
    path: '/docs/doc/:id/edit-info',
    method: 'POST',
    fields: [
        'categories',
        'expired_date',
        'effected_date',
        'published_date',
        'issued_place_id',
    ],
    fieldTypes,
    schema: documentSchema,
    transform: createTransform(documentSchema, 'data'),
}

export const doc_removeDocument_Api = {
    backend: `Route::post('docs/doc/{id}/delete', 'DocumentController@deleteDocument');`,
    root: API_ROOT_URL,
    path: '/docs/doc/:id/delete',
    method: 'POST',
    schema: documentSchema,
    transform: createTransform(documentSchema, 'data'),
}
export const docs_createDocRelationship_Api = {
    backend: `Route::post('docs/doc/{id}/doc-relation/create', 'DocumentController@createRelationship');`,
    root: API_ROOT_URL,
    path: '/docs/doc/:id/doc-relation/create',
    method: 'POST',
    fields: ['link_type', 'linked_document_id'],
    fieldTypes,
}

export const docs_fetchDocRelations_Api = {
    backend: `Route::get('docs/doc/{id}/relation/{rel_type}/gets', 'DocumentController@fetchDocRelations');`,
    root: API_ROOT_URL,
    path: '/docs/doc/:id/relation/:rel_type/gets',
    method: 'GET',
    paramsFields: ['page', 'status', 'keyword', 'document_type_id'],
}

export const docs_editRelationship_Api = {
    backend: `Route::post('docs/doc-relation/:id/edit', 'DocumentController@editRelationship');`,
    root: API_ROOT_URL,
    path: '/docs/doc-relation/:id/edit',
    method: 'POST',
}

export const docs_deleteRelationship_Api = {
    backend: `Route::post('docs/doc-relation/{id}/delete', 'DocumentController@deleteRelationship');`,
    root: API_ROOT_URL,
    path: '/docs/doc-relation/:id/delete',
    method: 'POST',
}

export const docs_generateRelationshipLinks_Api = {
    backend: `Route::post('relationships/doc-relation/{id}/generate', 'RelationshipController@autoGenerateLinks');`,
    root: API_ROOT_URL,
    path: '/relationships/doc-relation/:id/generate',
    method: 'POST',
}

// Route::get('docs/doc/{id}/extra-info', 'DocController@getExtraDataById');
export const doc_getExtraDataById_Api = {
    backend: `Route::get('docs/doc/{id}/extra-info', 'FeedController@getExtraDataById')`,
    root: API_ROOT_URL,
    path: '/docs/doc/:id/extra-info',
    method: 'GET',
    schema: documentSchema,
    fields,
    fieldTypes,
    transform: createTransform(documentSchema, 'data'),
}

export const doc_addKeyword_Api = {
    backend: `Route::post('docs/doc/{id}/add-keyword', 'DocController@addKeyword');`,
    root: API_ROOT_URL,
    path: '/docs/doc/:id/add-keyword',
    method: 'POST',
    fields,
    fieldTypes,
    schema: documentSchema,
    transform: createTransform(documentSchema, 'data'),
}

export const doc_removeKeyword_Api = {
    backend: `Route::post('docs/doc/{id}/keyword-ref/{ref_id}/remove-keyword', 'DocController@removeKeyword');`,
    root: API_ROOT_URL,
    path: '/docs/doc/:id/keyword-ref/:ref_id/remove-keyword',
    method: 'POST',
    fields,
    fieldTypes,
    schema: documentSchema,
    transform: createTransform(documentSchema, 'data'),
}

export const doc_addReferenceLinks_Api = {
    backend: `Route::post('docs/doc/{id}/update-ref-links-by-keyword', 'DocController@updateReferenceLinks');`,
    root: API_ROOT_URL,
    path: '/docs/doc/:id/update-ref-links-by-keyword',
    method: 'POST',
    fields,
    fieldTypes,
    transform: createTransform(documentSchema, 'data'),
}

export const doc_removeReferenceLinks_Api = {
    backend: `Route::post('docs/doc/{id}/remove-ref-links-by-keyword', 'DocController@removeReferenceLinks');`,
    root: API_ROOT_URL,
    path: '/docs/doc/:id/remove-ref-links-by-keyword',
    method: 'POST',
    fields,
    fieldTypes,
    transform: createTransform(documentSchema, 'data'),
}

export const doc_editContentByIndex_Api = {
    backend: `Route::post('docs/doc/{id}/update-content-by-index', 'DocController@editContent');`,
    root: API_ROOT_URL,
    path: '/docs/doc/:id/update-content-by-index',
    method: 'POST',
    fields,
    fieldTypes,
    schema: documentSchema,
    transform: createTransform(documentSchema, 'data'),
}

export const doc_removeContentByIndex_Api = {
    backend: `Route::post('docs/doc/{id}/remove-content-by-index', 'DocController@removeContent');`,
    root: API_ROOT_URL,
    path: '/docs/doc/:id/remove-content-by-index',
    method: 'POST',
    fields,
    fieldTypes,
    schema: documentSchema,
    transform: createTransform(documentSchema, 'data'),
}

export const doc_undoContentByIndex_Api = {
    backend: `Route::post('docs/doc/{id}/undo-content-by-index', 'DocController@undoEditContent');`,
    root: API_ROOT_URL,
    path: '/docs/doc/:id/undo-content-by-index',
    method: 'POST',
    fields,
    fieldTypes,
    schema: documentSchema,
    transform: createTransform(documentSchema, 'data'),
}

export const doc_editContentById_Api = {
    backend: `Route::post('docs/doc/{id}/update-content-by-id', 'DocumentController@editContentById'); // paragraph_id, paragraph_value`,
    root: API_ROOT_URL,
    path: '/docs/doc/:id/update-content-by-id',
    method: 'POST',
    fields,
    fieldTypes,
    schema: documentSchema,
    transform: createTransform(documentSchema, 'data'),
}

export const doc_undoContentById_Api = {
    backend: `Route::post('docs/doc/{id}/undo-content-by-id', 'DocumentController@undoEditContentById'); // paragraph_id`,
    root: API_ROOT_URL,
    path: '/docs/doc/:id/undo-content-by-id',
    method: 'POST',
    fields,
    fieldTypes,
    schema: documentSchema,
    transform: createTransform(documentSchema, 'data'),
}

export const doc_removeContentById_Api = {
    backend: `Route::post('docs/doc/{id}/remove-content-by-id', 'DocumentController@removeContentById'); // paragraph_id`,
    root: API_ROOT_URL,
    path: '/docs/doc/:id/remove-content-by-id',
    method: 'POST',
    fields,
    fieldTypes,
    schema: documentSchema,
    transform: createTransform(documentSchema, 'data'),
}

export const doc_insertContentBefore_Api = {
    backend: `Route::post('docs/doc/{id}/insert-before-content-by-id', 'DocumentController@insertBeforeContentById'); // paragraph_id, paragraph_value`,
    root: API_ROOT_URL,
    path: '/docs/doc/:id/insert-before-content-by-id',
    method: 'POST',
    fields,
    fieldTypes,
    schema: documentSchema,
    transform: createTransform(documentSchema, 'data'),
}

export const doc_insertContentAfter_Api = {
    backend: `Route::post('docs/doc/{id}/insert-after-content-by-id', 'DocumentController@insertAfterContentById'); // paragraph_id, paragraph_value`,
    root: API_ROOT_URL,
    path: '/docs/doc/:id/insert-after-content-by-id',
    method: 'POST',
    fields,
    fieldTypes,
    schema: documentSchema,
    transform: createTransform(documentSchema, 'data'),
}

// Route::get('docs/topic/get-latest', 'DocController@fetchLatestDocs');
export const docs_getLatestDocs_Api = {
    backend: `Route::get('docs/topic/get-latest', 'DocController@fetchLatestDocs');`,
    root: API_ROOT_URL,
    path: '/docs/topic/get-latest',
    method: 'GET',
    paramsFields: ['document_type', 'document_type_id', 'categories'],
    schema: documentSchema,
    transform: createListTransform(documentSchema),
}

// Route::get('docs/topic/{topic}/gets', 'PostController@fetchDocsByTopic');
export const docs_getFeedsByTopic_Api = {
    backend: `Route::get('docs/topic/{topic}/gets', 'PostController@fetchDocsByTopic');`,
    root: API_ROOT_URL,
    path: '/docs/topic/:id/gets',
    method: 'GET',
    paramsFields: ['document_type', 'document_type_id', 'categories'],
    schema: documentSchema,
    transform: createListTransform(documentSchema),
}

export const docs_updateSyncContent_Api = {
    backend: `Route::post('docs/doc/{id}/update-sync-content', 'DocumentController@updateSyncContent');`,
    root: API_ROOT_URL,
    path: '/docs/doc/:id/update-sync-content',
    method: 'POST',
    schema: documentSchema,
    transform: createTransform(documentSchema, 'data'),
}

export const docs_updateSyncFixedContent_Api = {
    backend: `Route::post('docs/doc/{id}/update-sync-fixed-content', 'DocumentController@updateSyncFixedContent');');`,
    root: API_ROOT_URL,
    path: '/docs/doc/:id/update-sync-fixed-content',
    method: 'POST',
    schema: documentSchema,
    transform: createTransform(documentSchema, 'data'),
}

export const docs_syncDocument2Codi_Api = {
    backend: `Route::post('docs/doc/{id}/sync-document-2-codi', 'DocumentController@syncDocument2Codi');`,
    root: API_ROOT_URL,
    path: '/docs/doc/:id/sync-document-2-codi',
    method: 'POST',
    schema: documentSchema,
    transform: createTransform(documentSchema, 'data'),
}

export const docs_getLatestDocuments_Api = {
    backend: `Route::get('docs/doc/get-latest', 'DocumentController@getLatestDocuments');`,
    root: API_ROOT_URL,
    path: '/docs/doc/get-latest',
    method: 'GET',
    paramsFields: ['level_type'],
    schema: documentSchema,
    transform: createListTransform(documentSchema),
}

export const docs_getRecentItems_Api = {
    backend: `Route::get('docs/get-recently-items', 'DocumentController@getRecentlyItems');`,
    root: API_ROOT_URL,
    path: '/docs/get-recently-items',
    method: 'GET',
    schema: documentSchema,
    transform: createListTransform(documentSchema),
}

export const codi_getRecentItems_Api = {
    backend: `Route::get('codi-documents/get-recently-items', 'CodiDocumentController@getRecentlyItems');`,
    root: API_ROOT_URL,
    path: '/codi-documents/get-recently-items',
    method: 'GET',
    schema: codiDocumentSchema,
    transform: createListTransform(codiDocumentSchema),
}

export const docs_getCodiDocuments_Api = {
    backend: `Route::get('codi-documents/gets', 'CodiDocumentController@getCodiDocuments');`,
    root: API_ROOT_URL,
    path: '/codi-documents/gets',
    method: 'GET',
    schema: codiDocumentSchema,
    paramsFields: ['keyword', 'sort_by', 'cate_id', 'document_type_id', 'document_group_id', 'sub_document_type_id', 'sub_children_document_type_id', 'year_from', 'year_to', 'language', 'non_bible', 'group_by_variant', 'page'],
    transform: createListTransform(codiDocumentSchema),
}


export const docs_getEcclesiasticType_Api = {
    backend: `Route::get('codi-documents/document-type/{id}/fetch-subs', 'CodiDocumentController@getSubDocumentType');`,
    root: API_ROOT_URL,
    path: '/codi-documents/document-type/:id/fetch-subs',
    method: 'GET',
    schema: codiDocumentSchema,
    paramsFields: ['document_type_id', 'document_group_id', 'sub_document_type_id', 'sub_children_document_type_id', 'language'],
    transform: createListTransform(codiDocumentSchema),
}

export const docs_getSubstantiveById_Api = {
    backend: `Route::get('codi-documents/codi-document/{id}', 'SubstantiveDocumentController@getById');`,
    root: API_ROOT_URL,
    path: '/codi-documents/codi-document/:id',
    method: 'GET',
    schema: codiDocumentSchema,
    paramsFields: ['variant_codi_document_id', 'with_first_row'],
    transform: createTransform(codiDocumentSchema, 'data'),
}

export const docs_getSubstantiveDocumentsRowHistory_Api = {
    backend: `Route::get('codi-documents/codi-document-rows/{id}/get-history', 'SubstantiveDocumentController@getSubstantiveDocumentsRowHistory');`,
    root: API_ROOT_URL,
    path: '/codi-documents/codi-document-rows/:id/get-history',
    method: 'GET',
}

export const docs_reGenerateSyncCodiDocument_Api = {
    backend: `Route::post('codi-documents/codi-document/{id}/re-generate', 'CodiDocumentController@reGenerateSyncCodiDocument');`,
    root: API_ROOT_URL,
    path: '/codi-documents/codi-document/:id/re-generate',
    method: 'POST',
    schema: codiDocumentSchema,
    transform: createTransform(codiDocumentSchema, 'data'),
}

export const docs_updateSyncInfoCodiDocument_Api = {
    backend: `Route::post('codi-documents/codi-document/{id}/sync-infos', 'CodiDocumentController@syncCodiInfos');`,
    root: API_ROOT_URL,
    path: '/codi-documents/codi-document/:id/sync-infos',
    method: 'POST',
    schema: codiDocumentSchema,
    transform: createTransform(codiDocumentSchema, 'data'),
}

export const docs_updateSyncReformat_Api = {
    backend: `Route::post('codi-documents/codi-document/{id}/re-format', 'CodiDocumentController@updateSyncReformat');`,
    root: API_ROOT_URL,
    path: '/codi-documents/codi-document/:id/re-format',
    method: 'POST',
    schema: codiDocumentSchema,
    transform: createTransform(codiDocumentSchema, 'data'),
}

export const docs_fetchCodiDocuments_Api = {
    backend: `Route::get('codi-documents/lookup-codi-documents', 'CodiDocumentController@fetchCodiDocuments'); // param: keyword`,
    root: API_ROOT_URL,
    path: '/codi-documents/lookup-codi-documents',
    method: 'GET',
    paramsFields: ['keyword', 'includes', 'language'],
}

export const docs_fetchAllCodiDocuments_Api = {
    backend: `Route::get('codi-documents/lookup-all-codi-documents', 'CodiDocumentController@fetchAllCodiDocuments');`,
    root: API_ROOT_URL,
    path: '/codi-documents/lookup-all-codi-documents',
    method: 'GET',
    paramsFields: ['keyword'],
}

export const docs_fetchAdjDocuments_Api = {
    backend: `Route::get('adj-documents/lookup-adj-documents', 'AdjDocumentController@fetchAdjDocuments');
  // param: keyword`,
    root: API_ROOT_URL,
    path: '/adj-documents/lookup-adj-documents',
    method: 'GET',
    paramsFields: ['keyword'],
}

export const docs_fetchAdjDocumentsValidOnCodiDocumentRow_Api = {
    backend: `Route::get('adj-documents/codi-document-row/{id}/lookup-adj-documents', 'AdjDocumentController@fetchAdjDocumentsValidOnCodiDocumentRow');
  // param: keyword`,
    root: API_ROOT_URL,
    path: '/adj-documents/codi-document-row/:id/lookup-adj-documents',
    method: 'GET',
    paramsFields: ['keyword'],
}

export const docs_fetchCodiDocumentRows_Api = {
    backend: `Route::get('codi-documents/codi-document/{id}/lookup-codi-document-rows', 'CodiDocumentController@fetchCodiDocumentRows');`,
    root: API_ROOT_URL,
    path: '/codi-documents/codi-document/:id/lookup-codi-document-rows',
    method: 'GET',
    paramsFields: ['keyword'],
}

export const docs_searchCodiDocumentRows_Api = {
    backend: `Route::get('codi-documents/codi-document/{id}/search-codi-document-rows', 'CodiDocumentController@searchCodiDocumentRows');`,
    root: API_ROOT_URL,
    path: '/codi-documents/codi-document/:id/search-codi-document-rows',
    method: 'GET',
    paramsFields: ['keyword'],
}

export const docs_fetchAdjDocumentRows_Api = {
    backend: `Route::get('adj-documents/adj-document/{id}/lookup-adj-document-rows', 'AdjDocumentController@fetchAdjDocumentRows');`,
    root: API_ROOT_URL,
    path: '/adj-documents/adj-document/:id/lookup-adj-document-rows',
    method: 'GET',
    paramsFields: ['keyword'],
}

export const docs_getBiblePageMeta_Api = {
    backend: `Route::get('codi-documents/get-bible-meta', 'CodiDocumentController@getBiblePageMeta');`,
    root: API_ROOT_URL,
    path: '/codi-documents/get-bible-meta',
    method: 'GET',
    paramsFields: [],
}

export const docs_addCodiDocumentRow_Api = {
    backend: `Route::post('codi-documents/codi-document/{id}/codi-document-row/{row_id}/add', 'AdjDocumentController@addCodiDocumentRow');
  // content, is_html: [1: html, 0: text], index_typecd, index_cd, adj_document_row_id`,
    root: API_ROOT_URL,
    path: '/codi-documents/codi-document/:id/codi-document-row/:row_id/add',
    method: 'POST',
    schema: codiDocumentSchema,
    transform: createTransform(codiDocumentSchema, 'data'),
}

export const docs_supplyCodiDocumentRow_Api = {
    backend: `Route::post('codi-documents/codi-document/{id}/codi-document-row/{row_id}/supply', 'AdjDocumentController@supplyCodiDocumentRow');
  // content, is_html: [1: html, 0: text], index_typecd, index_cd`,
    root: API_ROOT_URL,
    path: '/codi-documents/codi-document/:id/codi-document-row/:row_id/supply',
    method: 'POST',
    schema: codiDocumentSchema,
    transform: createTransform(codiDocumentSchema, 'data'),
}

export const docs_editCodiDocumentRow_Api = {
    backend: `Route::post('codi-documents/codi-document/{id}/codi-document-row/{row_id}/edit', 'AdjDocumentController@editCodiDocumentRow');
  // content, is_html: [1: html, 0: text]`,
    root: API_ROOT_URL,
    path: '/codi-documents/codi-document/:id/codi-document-row/:row_id/edit',
    method: 'POST',
    schema: codiDocumentSchema,
    transform: createTransform(codiDocumentSchema, 'data'),
}

export const docs_amendCodiDocumentRow_Api = {
    backend: `Route::post('codi-documents/codi-document/{id}/codi-document-row/{row_id}/amend', 'AdjDocumentController@amendCodiDocumentRow');
  // content, is_html: [1: html, 0: text]`,
    root: API_ROOT_URL,
    path: '/codi-documents/codi-document/:id/codi-document-row/:row_id/amend',
    method: 'POST',
    schema: codiDocumentSchema,
    transform: createTransform(codiDocumentSchema, 'data'),
}

export const docs_cancelCodiDocumentRow_Api = {
    backend: `Route::post('codi-documents/codi-document/{id}/codi-document-row/{row_id}/cancel', 'AdjDocumentController@cancelCodiDocumentRow');
  // adj_document_row_id`,
    root: API_ROOT_URL,
    path: '/codi-documents/codi-document/:id/codi-document-row/:row_id/cancel',
    method: 'POST',
    schema: codiDocumentSchema,
    transform: createTransform(codiDocumentSchema, 'data'),
}

export const docs_deleteCodiDocumentRow_Api = {
    backend: `Route::post('codi-documents/codi-document/{id}/codi-document-row/{row_id}/delete', 'AdjDocumentController@deleteCodiDocumentRow');`,
    root: API_ROOT_URL,
    path: '/codi-documents/codi-document/:id/codi-document-row/:row_id/delete',
    method: 'POST',
    schema: codiDocumentSchema,
    transform: createTransform(codiDocumentSchema, 'data'),
}

export const docs_getCodiDocumentsRowDetails_Api = {
    backend: `Route::get('codi-documents/codi-document-rows/{id}/get-details', 'CodiDocumentController@getCodiDocumentsRowDetails');`,
    root: API_ROOT_URL,
    path: '/codi-documents/codi-document-rows/:id/get-details',
    method: 'GET',
    paramsFields: ['hierarchy_level'],
}

export const docs_getSubCodiDocumentRows_Api = {
    backend: `Route::get('codi-documents/codi-document/{id}/codi-document-row/{row_id}/get-sub-rows', 'AdjDocumentController@getSubCodiDocumentRows');`,
    root: API_ROOT_URL,
    path: '/codi-documents/codi-document/:id/codi-document-row/:row_id/get-sub-rows',
    method: 'GET',
}

export const docs_reArrangeCodiDocumentRow_Api = {
    backend: `Route::post('codi-documents/codi-document/{id}/codi-document-row/{row_id}/re-arrange', 'AdjDocumentController@reArrangeCodiDocumentRow');
  // codi_document_row_ids`,
    root: API_ROOT_URL,
    path: '/codi-documents/codi-document/:id/codi-document-row/:row_id/re-arrange',
    method: 'POST',
    schema: codiDocumentSchema,
    transform: createTransform(codiDocumentSchema, 'data'),
}

export const docs_getCodiExtraDataById_Api = {
    backend: `Route::get('codi-documents/codi-document/{id}/extra-info', 'CodiDocumentController@getExtraDataById');`,
    root: API_ROOT_URL,
    path: '/codi-documents/codi-document/:id/extra-info',
    method: 'GET',
    schema: codiDocumentSchema,
    transform: createTransform(codiDocumentSchema, 'data'),
}

export const docs_getCodiLinks_Api = {
    backend: `Route::get('relationships/{type}/{id}/{related_type}/get-links', 'RelationshipController@getLinks');`,
    root: API_ROOT_URL,
    path: '/relationships/:type/:id/:related_type/get-links',
    method: 'GET',
}

export const docs_getLinksGroupByDates_Api = {
    backend: `Route::get('relationships/{type}/{id}/{related_type}/get-link-by-dates', 'RelationshipController@getLinksGroupByDates');`,
    root: API_ROOT_URL,
    path: '/relationships/:type/:id/:related_type/get-link-by-dates',
    method: 'GET',
}

export const docs_getCodiReservedLinks_Api = {
    backend: `Route::get('relationships/{type}/{id}/{related_type}/get-reserved-links', 'RelationshipController@getReservedLinks');`,
    root: API_ROOT_URL,
    path: '/relationships/:type/:id/:related_type/get-reserved-links',
    method: 'GET',
}

export const docs_createCodiLink_Api = {
    backend: `Route::post('relationship/{type}/{id}/add', 'RelationshipController@createLink');// params: link_type, link_id, related_type, description`,
    root: API_ROOT_URL,
    path: '/relationships/:type/:id/add',
    method: 'POST',
    schema: codiDocumentSchema,
    transform: createTransform(codiDocumentSchema, 'data'),
}

export const docs_editCodiLink_Api = {
    backend: `Route::post('relationship/{id}/delete', 'RelationshipController@editLink');`,
    root: API_ROOT_URL,
    path: '/relationships/relationship/:id/edit',
    method: 'POST',
    schema: codiDocumentSchema,
    transform: createTransform(codiDocumentSchema, 'data'),
}

export const docs_deleteCodiLink_Api = {
    backend: `Route::post('relationship/{id}/delete', 'RelationshipController@deleteLink');`,
    root: API_ROOT_URL,
    path: '/relationships/relationship/:id/delete',
    method: 'POST',
    schema: codiDocumentSchema,
    transform: createTransform(codiDocumentSchema, 'data'),
}

export const doc_editCodiDocument_Api = {
    backend: `Route::post('codi-documents/codi-document/{id}/edit', 'CodiDocumentController@editCodiDocument');`,
    root: API_ROOT_URL,
    path: '/codi-documents/codi-document/:id/edit',
    method: 'POST',
    fieldTypes,
    schema: codiDocumentSchema,
    transform: createTransform(codiDocumentSchema, 'data'),
}

export const docs_removeCodiDocument_Api = {
    backend: `Route::post('codi-documents/codi-document/{id}/remove', 'CodiDocumentController@deleteCodiDocument');`,
    root: API_ROOT_URL,
    path: '/codi-documents/codi-document/:id/remove',
    method: 'POST',
    schema: codiDocumentSchema,
    transform: createTransform(codiDocumentSchema, 'data'),
}

export const docs_mergeCodiAmendments_Api = {
    backend: `Route::post('codi-documents/codi-document/{id}/merge-amendments', 'CodiDocumentController@mergeAmendments');`,
    root: API_ROOT_URL,
    path: '/codi-documents/codi-document/:id/merge-amendments',
    method: 'POST',
    schema: codiDocumentSchema,
    transform: createTransform(codiDocumentSchema, 'data'),
}

export const doc_setPrevCodiDocument_Api = {
    backend: `Route::post('codi-documents/codi-document/{id}/set-prev-codi', 'CodiDocumentController@setPrevCodiDocument');`,
    root: API_ROOT_URL,
    path: '/codi-documents/codi-document/:id/set-prev-codi',
    method: 'POST',
    fieldTypes,
    schema: codiDocumentSchema,
    transform: createTransform(codiDocumentSchema, 'data'),
}

export const docs_getDocRelationLinkDetails_Api = {
    backend: `Route::get('relationships/doc-relation/{id}/{related_type}/get-doc-relation-link-details', 'RelationshipController@getDocRelationLinkDetails');
  // id ~doc_relation_id, related_type ~in: instruction,replacement`,
    root: API_ROOT_URL,
    path: '/relationships/doc-relation/:id/:related_type/get-doc-relation-link-details',
    method: 'GET',
}

export const docs_getCodiDocumentEditReport_Api = {
    backend: `Route::get('codi-documents/related-type/{type}/get-edit-report', 'CodiDocumentController@getCodiDocumentEditReport');`,
    root: API_ROOT_URL,
    path: '/codi-documents/related-type/:type/get-edit-report',
    method: 'GET',
    paramsFields: ['page', 'keyword', 'sort_by', 'document_type_id'],
}

export const docs_fetchCodiDocumentRelations_Api = {
    backend: `Route::get('codi-documents/codi-document/{id}/relation/{rel_type}/gets', 'DocumentController@fetchCodiDocumentRelations');`,
    root: API_ROOT_URL,
    path: '/codi-documents/codi-document/:id/relation/:rel_type/gets',
    method: 'GET',
    paramsFields: ['page', 'document_type_id'],
}

export const docs_fetchCodiRelations_Api = {
    backend: `Route::get('relationships/codi-document/{id}/relation/{rel_type}/gets', 'RelationshipController@docs_fetchCodiRelations_Api'); `,
    root: API_ROOT_URL,
    path: '/relationships/codi-document/:id/relation/:rel_type/gets',
    method: 'GET',
    paramsFields: ['page', 'document_type_id'],
}

export const docs_fetchDetailCodiDocumentRelations_Api = {
    backend: `Route::get('relationships/codi-document/{id}/linked-codi-document/{link_id}/relation/{rel_type}/get-details', 'RelationshipController@fetchDetailCodiDocumentRelations');
  `,
    root: API_ROOT_URL,
    path: '/relationships/codi-document/:id/linked-codi-document/:link_id/relation/:rel_type/get-details',
    method: 'GET',
    paramsFields: ['page'],
}


export const docs_fetchMusicLinkedCodiRelations_Api = {
    backend: `Route::get('relationships/music/{id}/relation/{rel_type}/gets', 'RelationshipController@fetchMusicLinkedCodiRelations');`,
    root: API_ROOT_URL,
    path: '/relationships/music/:id/relation/:rel_type/gets',
    method: 'GET',
    paramsFields: ['page', 'music_type_id'],
}

export const docs_fetchDetailMusicLinkedCodiRelations_Api = {
    backend: `Route::get('relationships/music/{id}/linked-codi-document/{link_id}/relation/{rel_type}/get-details', 'RelationshipController@fetchDetailMusicLinkedCodiRelations');`,
    root: API_ROOT_URL,
    path: '/relationships/music/:id/linked-codi-document/:link_id/relation/:rel_type/get-details',
    method: 'GET',
    paramsFields: ['page'],
}

export const doc_changeCodiDocumentRowType_Api = {
    backend: `Route::post('codi-documents/codi-document/{id}/codi-document-row/{row_id}/change-row-type', 'CodiDocumentController@changeCodiDocumentRowType'); `,
    root: API_ROOT_URL,
    path: '/codi-documents/codi-document/:id/codi-document-row/:row_id/change-row-type',
    method: 'POST',
    fieldTypes,
    schema: codiDocumentSchema,
    transform: createTransform(codiDocumentSchema, 'data'),
}

export const docs_getRawDocuments_Api = {
    backend: `Route::get('staging-data/stg-law-raws/gets', 'StagingLawRawController@getRaws');`,
    root: API_ROOT_URL,
    path: '/staging-data/stg-law-raws/gets',
    method: 'GET',
    paramsFields: ['keyword', 'sort_by', 'page'],
}

export const docs_getRawDocumentById_Api = {
    backend: `Route::get('staging-data/stg-law-raws/{id}/get', 'StagingLawRawController@getById');`,
    root: API_ROOT_URL,
    path: '/staging-data/stg-law-raws/:id/get',
    method: 'GET',
}

export const doc_changeRawDocumentStatus_Api = {
    backend: `Route::post('staging-data/stg-law-raws/{id}/change-status', 'StagingLawRawController@changeStatus');`,
    root: API_ROOT_URL,
    path: '/staging-data/stg-law-raws/:id/change-status',
    method: 'POST',
    fieldTypes,
}

export const doc_createRawDocument_Api = {
    backend: `Route::post('staging-data/stg-law-raws/create-raw', 'StagingLawRawController@createRaw');`,
    root: API_ROOT_URL,
    path: '/staging-data/stg-law-raws/create-raw',
    method: 'POST',
}

export const doc_updateRawDocument_Api = {
    backend: `Route::post('staging-data/stg-law-raws/{id}/edit-raw', 'StagingLawRawController@editRaw');`,
    root: API_ROOT_URL,
    path: '/staging-data/stg-law-raws/:id/edit-raw',
    method: 'POST',
}

export const doc_deleteRawDocument_Api = {
    backend: `Route::post('staging-data/stg-law-raws/{id}/delete-raw', 'StagingLawRawController@deleteRaw');`,
    root: API_ROOT_URL,
    path: '/staging-data/stg-law-raws/:id/delete-raw',
    method: 'POST',
}

export const doc_createDocument_Api = {
    backend: `Route::post('docs/doc/create', 'DocumentController@createDocument');`,
    root: API_ROOT_URL,
    path: '/docs/doc/create',
    method: 'POST',
    schema: documentSchema,
    transform: createTransform(documentSchema, 'data'),
}

export const doc_getManualDocuments_Api = {
    backend: `Route::get('docs/doc/get-manual-documents', 'DocumentController@getManualDocuments')`,
    root: API_ROOT_URL,
    path: '/docs/doc/get-manual-documents',
    method: 'GET',
    paramsFields: ['keyword', 'sort_by', 'page'],
    schema: documentSchema,
    transform: createTransform(documentSchema, 'data'),
}

export const doc_queryCodiDocumentRows = {
    backend: `Route::get('codi-documents/query-codi-document-rows', 'CodiDocumentController@queryCodiDocumentRows'); // param: keyword`,
    root: API_ROOT_URL,
    path: '/codi-documents/query-codi-document-rows',
    method: 'GET',
    paramsFields: ['category', 'keyword', 'language', 'document_type'],
}

export const doc_queryBibleRaw_Api = {
    backend: `Route::get('codi-documents/query-bible-raw', 'CodiDocumentController@queryBibleRaw');`,
    root: API_ROOT_URL,
    path: '/codi-documents/query-bible-raw',
    method: 'GET',
    paramsFields: ['category', 'keyword', 'language', 'document_type', 'search_type'],
}

export const doc_getCodiDocumentsRowsByPage_Api = {
    backend: `Route::get('codi-documents/codi-document-rows/{id}/get-by-page', 'CodiDocumentController@getCodiDocumentsRowsByPage');`,
    root: API_ROOT_URL,
    path: '/codi-documents/codi-document-rows/:id/get-by-page',
    method: 'GET',
    paramsFields: ['keyword', 'sort_by', 'page', 'variant_codi_document_id', 'variant_codi_document_row_id'],
}

export const doc_getKeywordDefinitionById_Api = {
    backend: `Route::get('definitions/keyword/{id}/get', 'DefinitionController@getKeywordDefinitionById');`,
    root: API_ROOT_URL,
    path: '/definitions/keyword/:id/get',
    method: 'GET',
    paramsFields: [],
}

export const doc_fetchLatestCodiDocs_Api = {
    backend: `Route::get('codi-documents/topic/get-latest', 'CodiDocumentController@fetchLatestCodiDocs');`,
    root: API_ROOT_URL,
    path: '/codi-documents/topic/get-latest',
    method: 'GET',
    paramsFields: ['keyword', 'sort_by', 'page', 'categories'],
    schema: codiDocumentSchema,
    transform: createListTransform(codiDocumentSchema),
}

export const doc_fetchCodiDocsByDocumentType_Api = {
    backend: `Route::get('codi-documents/document-type/{id}/fetch', 'CodiDocumentController@fetchCodiDocsByDocumentType');`,
    root: API_ROOT_URL,
    path: '/codi-documents/document-type/:id/fetch',
    method: 'GET',
    paramsFields: ['keyword', 'sort_by', 'page', 'categories', 'language', 'version'],
}

export const doc_fetchCodiDocsByTopic_Api = {
    backend: `Route::get('codi-documents/topic/{topic}/gets', 'CodiDocumentController@fetchCodiDocsByTopic');`,
    root: API_ROOT_URL,
    path: '/codi-documents/topic/:id/gets',
    method: 'GET',
    paramsFields: ['keyword', 'sort_by', 'page'],
    schema: codiDocumentSchema,
    transform: createListTransform(codiDocumentSchema),
}

export const user_fetchSuggestionEcclesiasticsAppChoices_Api = {
    name: 'user_fetchSuggestionEcclesiasticsAppChoices_Api',
    backend: `Route::get('recommendations/ecclesiastics/suggested-items', 'PromoteController@getEcclesiastics');`,
    root: API_ROOT_URL,
    path: '/recommendations/ecclesiastics/suggested-items',
    method: 'GET',
    paramsFields: ['category_id'],
    schema: codiDocumentSchema,
    transform: createListTransform(codiDocumentSchema),
}


export const docs_getLibraryStats_Api = {
    backend: `Route::get('codi-documents/get-library-stats', 'CodiDocumentController@getLibraryStats');`,
    root: API_ROOT_URL,
    path: '/codi-documents/get-library-stats',
    method: 'GET',
}

export const docs_getPopesWithYearRange_Api = {
    backend: `Route::get('codi-documents/document-type/{id}/get-popes-with-range', 'CodiDocumentController@getPopesWithYearRange');`,
    root: API_ROOT_URL,
    path: '/codi-documents/document-type/:id/get-popes-with-range',
    method: 'GET',
    paramsFields: ['language'],
}

export const docs_getTimeline_Api = {
    backend: `Route::get('codi-documents/get-timeline', 'CodiDocumentController@getTimeline');`,
    root: API_ROOT_URL,
    path: '/codi-documents/get-timeline',
    method: 'GET',
    paramsFields: ['document_type_id', 'year_from', 'year_to', 'page'],
    schema: codiDocumentSchema,
    transform: createListTransform(codiDocumentSchema),
}

export const docs_getDocumentTypeLanguages_Api = {
    backend: `Route::get('codi-documents/document-type/{id}/get-languages', 'CodiDocumentController@getDocumentTypeLanguages');`,
    root: API_ROOT_URL,
    path: '/codi-documents/document-type/:id/get-languages',
    method: 'GET',
}

export const doc_fetchCodiDocsByHierarchy_Api = {
    backend: `Route::get('codi-documents/document-type/{id}/get-hierarchy', 'CodiDocumentController@getHierarchyWithLatestDocs');`,
    root: API_ROOT_URL,
    path: '/codi-documents/document-type/:id/get-hierarchy',
    method: 'GET',
    paramsFields: ['keyword', 'sort_by', 'page', 'language'],
    schema: codiDocumentSchema,
    transform: createListTransform(codiDocumentSchema),
}

